export default __webpack_public_path__ + "static/media/Sintony-Bold.d90b6cb5.woff2";